import { Controller } from "stimulus";
import { debounce } from 'lodash';

const removeLearnerId = function () {
  const url = new URL(window.location.href);
  url.searchParams.delete('learner_id');
  const newUrl = url.search ? url.href : url.href.replace('?', '');
  window.history.replaceState({}, document.title, newUrl);
}

export default class extends Controller {
  static targets = [
    'checkBox', 'selectAll', 'selectAllLabel', 'clearSelectionLabel', 'selectAllParam', 'selectForm', 'newForm',
    'counterText', 'actionBar', 'selectAllBtn', 'allLearners', 'filterForm', 'editNotesButton',
    'internalNotesArea', 'internalNotesForm', 'notifyAtForm', 'notificationDate'
  ]

  initialize() {
    this.searchLearner = debounce(this.searchLearner, 1500).bind(this)
  }

  connect() {
    $('#learner-show-modal').on('hidden.bs.modal', function (event) {
      event.preventDefault();
      removeLearnerId();
    })
    this.handleInsightsActions();
  }

  handleCheckboxSelect() {
    this.refreshCounter();

    if (event.target.checked) {
      if (!event.target.disabled) {
        $(event.target).closest('.table_line').addClass('table-active');
      }
    } else {
      $(event.target).closest('.table_line').removeClass('table-active');
    }

    this.handleLearnerSelected()
  }

  handleSelectAll() {
    if (event.target.checked) {
      $('.learner-checkbox:not(:disabled)').not(this).prop('checked', true);
      $('.table_line').each(function () {
        var checkbox = $(this).find('.learner-checkbox:not(:disabled)');
        if (checkbox.length > 0) {
          $(this).addClass('table-active');
        }
      });
    } else {
      $('.learner-checkbox').not(this).prop('checked', false);
      $('.table_line').removeClass('table-active')

      if (this.hasSelectAllLabelTarget) {
        this.selectAllLabelTarget.classList.add('d-none')
      }
    }

    this.refreshCounter();
    this.handleLearnerSelected()
    var enabledCheckboxes = this.checkBoxTargets.filter(obj => !obj.disabled);
    var selectedCount = this.checkBoxTargets.filter(obj => obj.checked).length

    if (selectedCount == enabledCheckboxes.length && this.hasSelectAllLabelTarget) {
      this.selectAllLabelTarget.classList.remove('d-none')
    } else {
      this.clearSelection()
    }
  }

  handleLearnerSelected() {
    var checked_boxes = this.checkBoxTargets.filter(obj => obj.checked)
    var selectedCount = checked_boxes.length
    this.clearSelection()
    this.handleRecertify(checked_boxes)

    if (selectedCount > 0) {
      $('.bulk-action-btn').removeClass('disabled-link')
      $(this.actionBarTarget).removeClass('d-none')
      $(this.selectAllBtnTarget).addClass('disabled')
    } else {
      $('.bulk-action-btn').addClass('disabled-link')
      $(this.actionBarTarget).addClass('d-none')
      $(this.selectAllBtnTarget).removeClass('disabled')
    }

    var enabledCheckboxes = this.checkBoxTargets.filter(obj => !obj.disabled);
    if (selectedCount != enabledCheckboxes.length) {
      $(this.allLearnersTarget).prop('checked', false);
    }
  }

  handleSelectCompanyLearners(e) {
    if (e.target.checked) {
      if (this.hasSelectAllLabelTarget) {
        this.selectAllLabelTarget.classList.add('d-none')
      }

      this.clearSelectionLabelTarget.classList.remove('d-none')

      if (this.hasSelectAllParamTarget) {
        this.selectAllParamTarget.value = true
      }

      $('.learners_counter').html($('.total_learners_count').val())
      $(this.counterTextTarget).html($('.total_learners_count').val() + " Selected")
    } else {
      if (this.hasSelectAllLabelTarget) {
        this.selectAllLabelTarget.classList.remove('d-none')
      }

      this.clearSelectionLabelTarget.classList.add('d-none')

      $(this.selectAllTarget).closest('span').removeClass('purple').addClass('orange')

      if (this.hasSelectAllParamTarget) {
        this.selectAllParamTarget.value = false
      }

      $('.learners_counter').html(this.checkBoxTargets.filter(obj => obj.checked).length)
      $(this.counterTextTarget).html(this.checkBoxTargets.filter(obj => obj.checked).length + " Selected")
    }
  }

  clearSelection() {
    if (this.hasSelectAllTarget && this.selectAllTarget.checked) {
      $(this.selectAllTarget).trigger('click')
    }

    if (this.hasSelectAllLabelTarget) {
      this.selectAllLabelTarget.classList.add('d-none')
    }
  }

  hideShowClassroomForm(event) {
    this.selectFormTarget.classList.toggle('d-none');
    this.newFormTarget.classList.toggle('d-none');

    if (event.target.checked) {
      $('.classroom-fields').attr('required', true)
    } else {
      $('.classroom-fields').removeAttr('required')
    }
  }

  hideShowNotifyForm(event) {
    this.notifyAtFormTarget.classList.toggle('d-none');

    if ($(event.target).data('notifyAt') == true) {
      $(this.notificationDateTarget).attr('required', true)
    } else {
      $(this.notificationDateTarget).removeAttr('required')
      $(this.notificationDateTarget).val('')
    }
  }

  refreshCounter() {
    var counter = this.checkBoxTargets.filter(obj => obj.checked).length;

    if (counter <= 0) {
      $('#bulk-action-counter').html('Bulk Actions');
      $(this.counterTextTarget).html('Select learners below');
      $('.learners_counter').html('all');
    } else {
      $('#bulk-action-counter').html(counter + ' SELECTED');
      $(this.counterTextTarget).html(counter + ' Selected');
      $('.learners_counter').html(counter);
    }
  }

  enableBar() {
    event.preventDefault();
    $(this.actionBarTarget).removeClass('d-none');
    $(this.selectAllBtnTarget).addClass('disabled');
  }

  disableBar() {
    $(this.actionBarTarget).addClass('d-none');
    $(this.selectAllBtnTarget).removeClass('disabled');
    $('.learner-checkbox').prop('checked', false);
    $(this.allLearnersTarget).prop('checked', false);
    $('.table_line').removeClass('table-active');
    $('.bulk-action-btn').addClass('disabled-link');
    this.clearSelection();
    $(this.counterTextTarget).html('Select learners below');
  }

  disableEmptyFilters() {
    $(this.filterFormTarget).find(':input').filter(function () {
      return ($(this).val() === '' || $(this).val() === null || ($(this).attr('name') === 'q[include_archived]') && $(this).val() === '0') && !($(this).attr('name') === 'q[compliance_status_eq]');
    }).prop('disabled', true);
  }

  enableEmptyFilters() {
    $(this.filterFormTarget).find(':input[disabled]').prop('disabled', false);
  }

  redirectToLearner(event) {
    if (!event.target.closest('.non-link')) {
      Rails.ajax({
        url: event.target.closest('.el-learner-row').dataset.href,
        type: 'GET',
        dataType: 'script'
      })
    }
  }

  bulkAssign() {
    $('#bulk-learner-form').attr('data-local', false);
    $('#bulk-learner-form').attr('data-remote', true);
  }

  reopenBulkAssign() {
    $('#bulkAssignButton').click();
  }

  toggleDatepicker(event) {
    var value = event.target.value;
    $('#' + event.target.dataset.pickerId).toggleClass('d-none', event.target.value !== '-1');
  }

  handleRecertify(elements) {
    const hasDueStatus = elements.some(element => element.dataset.status === 'due_for_recertification');

    $('[id="recertify"]').toggleClass('d-none', !hasDueStatus)
  }

  handleDocumentsAssign(event) {
    event.preventDefault();
    var policyIds = $('#learner_policy_ids').val();
    this.getPolicyRecurrence(policyIds);

    hideModalClasses();

    initializeDatePickers($('#bulk-post-assign-policies').find('.daterangefull'));
    $('#bulk-post-assign-policy-ids').val(policyIds);
    $('#bulk-post-assign-policies').modal('show');
  }

  getPolicyRecurrence(selectedValues) {
    Rails.ajax({
      url: `documents/recurrence?${$.param({ selected_policy_ids: selectedValues })}`,
      type: 'get',
      dataType: 'json',
      success: (data) => {
        $('#bulk-post-assign-policies #recertify-option').text(data);
      },
      error: (message, ajax, error) => {
        alert(message);
      }
    });
  }

  handleRemoteSubmit(event) {
    event.preventDefault();
    var form = event.target.form
    form.setAttribute("data-remote", "true");
    Rails.fire(form, 'submit');
  }

  AssignJournyLearners() {
    const selectedValues = this.checkBoxTargets
      .filter(obj => obj.checked && !obj.disabled)
      .map(obj => obj.value);

    hideModalClasses();
    $('#bulk-assign-journeys').modal('show');
    $('#btn-assign-journey-learner').prop('disabled', false);
    $('#learner-count').text(selectedValues.length)
  }

  toggleLearnerFilters(event) {
    hideModalClasses();

    const modals = ['assignTrainee', 'learnersFilters'];
    const currentModalId = event.target.closest('.modal').id;
    const toOpen = modals.find(modal => modal !== currentModalId);

    $(`#${toOpen}`).modal('show');
  }

  searchLearner() {
    $('#title-search').val($('#searchField').val());
    $('#learners-apply').click();
  }

  handleInsightsActions() {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);

    this.checkAndOpenChangeDueDateModal(params);
    this.checkAndOpenNotifyModal(params);
  }

  checkAndOpenChangeDueDateModal(params) {
    if (!params.get('open_change_due_date_modal')) { return }

    if (this.hasAllLearnersTarget && this.hasSelectAllLabelTarget) {
      this.allLearnersTarget.click();
      this.selectAllLabelTarget.click();

      requestAnimationFrame(() => {
        $('#bulkLearnerDueAt').modal('show');
      });
    }
  }

  checkAndOpenNotifyModal(params) {
    if (!params.get('open_notify_modal')) { return }

    if (this.hasAllLearnersTarget && this.hasSelectAllLabelTarget) {
      this.allLearnersTarget.click();
      this.selectAllLabelTarget.click();

      requestAnimationFrame(() => {
        $('#notifyLearner').modal('show');
      });
    }
  }

  removeUrlParameter(param) {
    const url = new URL(window.location.href);
    url.searchParams.delete(param);
    const newUrl = url.search ? url.href : url.href.replace('?', '');
    window.history.replaceState({}, document.title, newUrl);
  }

  editInternalNotes() {
    $(this.internalNotesAreaTarget).addClass('d-none')
    $(this.editNotesButtonTarget).addClass('d-none')
    $(this.internalNotesFormTarget).removeClass('d-none');
  }

  hideInternalNotesForm(event) {
    $(this.internalNotesAreaTarget).removeClass('d-none')
    $(this.editNotesButtonTarget).removeClass('d-none')
    $(this.internalNotesFormTarget).addClass('d-none');
  }

  toggleTrainingsDropdown(event) {
    let trainingsSelection = $('#unassign-trainings-selection')

    if ($(event.target).val() == 'true') {
      trainingsSelection.addClass('d-none')
    } else if ($(event.target).val() == 'false') {
      trainingsSelection.removeClass('d-none')
    }
  }

  toggleRecertificationDate(event) {
    $('#recertification-date-field').toggleClass('d-none', event.target.value == 'true')
  }

  toggleDueAt(event) {
    $('#trainings-selection-field').toggleClass('d-none', event.target.value == 'true')
    $('#trainings-selection-field select').val(null).trigger('change');
  }
}